export { default as EmailDetails, type EmailDetailsProps } from './EmailDetails';
